// Power-Up ARTWORK key -> image for the card's Picture box. The picture is the ONE template
// component that isn't CSS; every other part of a Pup card (name/color/modifier/description/
// flavor) renders from the backend payload. Keyed by the catalog's artKey — variants that
// share art share one entry (all four street copies of a card map to a single line), so a
// new backend card that reuses existing art needs NO frontend change at all. Add an image
// here (assets/pupCardPics) only when a genuinely new artwork is born.
import powerUpArt from '../../assets/pupCardPics/PowerUp_Pic.PNG';
import skipArt from '../../assets/pupCardPics/Skip_Pic.PNG';
import exchangeArt from '../../assets/pupCardPics/Exchange_Pic.PNG';
import demonicRitualArt from '../../assets/pupCardPics/DemonicRitual_Pic.png';
import flyingBlindArt from '../../assets/pupCardPics/FlyingBlind_Pic.png';
import goFishArt from '../../assets/pupCardPics/GoFish_pic.png';
import minusOneArt from '../../assets/pupCardPics/MinusOne_pic.png';
import oneMansTrashArt from '../../assets/pupCardPics/OneMansTrash_pic.png';
import peekArt from '../../assets/pupCardPics/Peek_Pic.png';
import peeperArt from '../../assets/pupCardPics/Peeper_Pic.png';
import plusOneArt from '../../assets/pupCardPics/PlusOne_pic.png';
import sacrificeArt from '../../assets/pupCardPics/Sacrifice_Pic.png';
import suitChangeArt from '../../assets/pupCardPics/SuitChange_Pic.png';
import wildThingsArt from '../../assets/pupCardPics/WhereTheWildthingsAre_Pic.png';
import additionalSupportArt from '../../assets/pupCardPics/AdditionalSupport_Pic.png';
import overflowArt from '../../assets/pupCardPics/Overflow_Pic.png';
import cancelArt from '../../assets/pupCardPics/Cancel_Pic.png';
import negotiationArt from '../../assets/pupCardPics/Negotiation_Pic.png';
import bindingContractArt from '../../assets/pupCardPics/BindingContract_Pic.png';
import participationArt from '../../assets/pupCardPics/Participation_Pic.png';
import sevenAteNineArt from '../../assets/pupCardPics/SevenAteNine_Pic.png';
import streamSniperArt from '../../assets/pupCardPics/StreamSniper_Pic.png';
import psychicArt from '../../assets/pupCardPics/Psychic_Pic.png';
import reverseArt from '../../assets/pupCardPics/Reverse_Pic.png';
// On-disk quirks kept verbatim again: BombPot's lowercase "_pic", DoublePLOBombPPot's doubled P.
import bombPotArt from '../../assets/pupCardPics/BombPot_pic.PNG';
import ploBombPotArt from '../../assets/pupCardPics/PLOBombPot_Pic.PNG';
import doublePloBombPotArt from '../../assets/pupCardPics/DoublePLOBombPPot_Pic.PNG';
import bountyButtonArt from '../../assets/pupCardPics/BountyButton_Pic.PNG';
import drawTwoArt from '../../assets/pupCardPics/DrawTwo_Pic.PNG';
import swiperArt from '../../assets/pupCardPics/Swiper_Pic.PNG';
// Gold tier art lives under goldCardPics/ (case-sensitive under the bundler — note the
// on-disk filename quirks kept verbatim: HalfBlinBandit, socialdistancing).
import shrinkifyArt from '../../assets/pupCardPics/goldCardPics/Shrinkify_Pic.png';
import premonitionArt from '../../assets/pupCardPics/goldCardPics/Premonition_Pic.png';
import rageArt from '../../assets/pupCardPics/goldCardPics/Rage_Pic.png';
import runItTwiceArt from '../../assets/pupCardPics/goldCardPics/RunItTwice_Pic.png';
import sacrificialCeremonyArt from '../../assets/pupCardPics/goldCardPics/SacrificialCeremony_Pic.png';
import saviorArt from '../../assets/pupCardPics/goldCardPics/Savior_Pic.png';
import shortKingArt from '../../assets/pupCardPics/goldCardPics/ShortKing_Pic.png';
import shutDownArt from '../../assets/pupCardPics/goldCardPics/ShutDown_Pic.png';
import socialDistancingArt from '../../assets/pupCardPics/goldCardPics/socialdistancing_Pic.png';
import spyMasterArt from '../../assets/pupCardPics/goldCardPics/SpyMaster_Pic.png';
import straightUpConnectedArt from '../../assets/pupCardPics/goldCardPics/StraightUpConnected_Pic.png';
import substitutionArt from '../../assets/pupCardPics/goldCardPics/Substitution_Pic.png';
import unexpectedGrowthArt from '../../assets/pupCardPics/goldCardPics/UnexpectedGrowth_Pic.png';
import jackpotArt from '../../assets/pupCardPics/goldCardPics/Jackpot_pic.png';
import juicingArt from '../../assets/pupCardPics/goldCardPics/Juicing_Pic.png';
import oneShortArt from '../../assets/pupCardPics/goldCardPics/OneShort_Pic.png';
import peacefulWandererArt from '../../assets/pupCardPics/goldCardPics/PeacefulWanderer_Pic.png';
import buttonUpArt from '../../assets/pupCardPics/goldCardPics/ButtonUp_Pic.png';
import counterGoldArt from '../../assets/pupCardPics/goldCardPics/Counter_Pic.png';
import goodEconomyArt from '../../assets/pupCardPics/goldCardPics/GoodEconomy_Pic.png';
import grandExchangeArt from '../../assets/pupCardPics/goldCardPics/GrandExchange_Pic.png';
import halfBlindBanditArt from '../../assets/pupCardPics/goldCardPics/HalfBlinBandit_Pic.png';
import futureSightArt from '../../assets/pupCardPics/goldCardPics/FutureSight_Pic.png';
import garbageCollectorArt from '../../assets/pupCardPics/goldCardPics/GarbageCollector_pic.png';
import hijackArt from '../../assets/pupCardPics/goldCardPics/Hijack_Pic.PNG';
import powerAcceleratorArt from '../../assets/pupCardPics/goldCardPics/PowerAccelerator_Pic.PNG';
import superSuitArt from '../../assets/pupCardPics/goldCardPics/SuperSuit_Pic.PNG';
import supplementalStrengthArt from '../../assets/pupCardPics/goldCardPics/SupplementalStrength_Pic.PNG';
import wildChildArt from '../../assets/pupCardPics/goldCardPics/WildChild_Pic.PNG';
import worthySacrificeArt from '../../assets/pupCardPics/goldCardPics/WorthySacrifice_Pic.PNG';
// Celestial tier art lives under celestialCardPics/ — on-disk filename quirks kept verbatim
// again: AceUpMySleeve uses a lowercase "_pic", DumpsterDiving spells the card's "Diver" as
// "Diving", and Trenbologna's file is "Ternbologna". Every file here is an uppercase .PNG.
import aceUpMySleeveArt from '../../assets/pupCardPics/celestialCardPics/AceUpMySleeve_pic.PNG';
import allSeeingEyeArt from '../../assets/pupCardPics/celestialCardPics/AllSeeingEye_Pic.PNG';
import bountyHunterArt from '../../assets/pupCardPics/celestialCardPics/BountyHunter_Pic.PNG';
import clairvoyanceArt from '../../assets/pupCardPics/celestialCardPics/Clairvoyance_Pic.PNG';
import dumpsterDiverArt from '../../assets/pupCardPics/celestialCardPics/DumpsterDiving_Pic.PNG';
import ghostArt from '../../assets/pupCardPics/celestialCardPics/Ghost_Pic.PNG';
import lifelineArt from '../../assets/pupCardPics/celestialCardPics/Lifeline_Pic.PNG';
import magicTrickArt from '../../assets/pupCardPics/celestialCardPics/MagicTrick_Pic.PNG';
import mindChangeArt from '../../assets/pupCardPics/celestialCardPics/MindChange_Pic.PNG';
import pacifistArt from '../../assets/pupCardPics/celestialCardPics/PaciFIST_Pic.PNG';
import powerInfusionArt from '../../assets/pupCardPics/celestialCardPics/PowerInfusion_Pic.PNG';
import ragingMadnessArt from '../../assets/pupCardPics/celestialCardPics/RagingMadness_Pic.PNG';
import redirectArt from '../../assets/pupCardPics/celestialCardPics/Redirect_Pic.PNG';
import shortestKingArt from '../../assets/pupCardPics/celestialCardPics/ShortestKing_Pic.PNG';
import trenbolognaArt from '../../assets/pupCardPics/celestialCardPics/Ternbologna_Pic.PNG';

const pupCardArt = {
  power_up: powerUpArt,
  skip: skipArt,
  exchange: exchangeArt,
  demonic_ritual: demonicRitualArt,
  flying_blind: flyingBlindArt,
  go_fish: goFishArt,
  minus_one: minusOneArt,
  one_mans_trash: oneMansTrashArt,
  peek: peekArt,
  peeper: peeperArt, // shared by all four Peeper street variants
  plus_one: plusOneArt,
  sacrifice: sacrificeArt,
  suit_change: suitChangeArt, // shared by all four Suit Change variants
  wild_things: wildThingsArt,
  additional_support: additionalSupportArt,
  overflow: overflowArt,
  cancel: cancelArt,
  negotiation: negotiationArt,
  binding_contract: bindingContractArt,
  participation: participationArt,
  seven_ate_nine: sevenAteNineArt,
  stream_sniper: streamSniperArt,
  psychic_one: psychicArt, // one artwork, three separate keys (Psychic 1/2/3 differ in depth)
  psychic_two: psychicArt,
  psychic_three: psychicArt,
  reverse: reverseArt,
  bomb_pot: bombPotArt,
  plo_bomb_pot: ploBombPotArt,
  double_plo_bomb_pot: doublePloBombPotArt,
  bounty_button: bountyButtonArt,
  draw_two: drawTwoArt,
  swiper: swiperArt,
  cancel_two: cancelArt, // Cancel2 deliberately inherits the Cancel artwork
  shrinkify: shrinkifyArt,
  premonition: premonitionArt,
  rage: rageArt,
  run_it_twice: runItTwiceArt,
  sacrificial_ceremony: sacrificialCeremonyArt,
  savior: saviorArt,
  short_king: shortKingArt,
  shut_down: shutDownArt,
  social_distancing: socialDistancingArt,
  spy_master: spyMasterArt,
  straight_up_connected: straightUpConnectedArt,
  substitution: substitutionArt,
  unexpected_growth: unexpectedGrowthArt,
  jackpot: jackpotArt,
  juicing: juicingArt,
  one_short: oneShortArt,
  peaceful_wanderer: peacefulWandererArt,
  button_up: buttonUpArt,
  counter_gold: counterGoldArt,
  good_economy: goodEconomyArt,
  grand_exchange: grandExchangeArt,
  half_blind_bandit: halfBlindBanditArt,
  future_sight: futureSightArt,
  garbage_collector: garbageCollectorArt,
  hijack: hijackArt,
  power_accelerator: powerAcceleratorArt,
  super_suit: superSuitArt,
  supplemental_strength: supplementalStrengthArt,
  wild_child: wildChildArt,
  worthy_sacrifice: worthySacrificeArt,
  counter_two: counterGoldArt, // Counter2 deliberately inherits the gold Counter artwork

  // CELESTIAL tier — all 15 artKeys are covered.
  ace_up_my_sleeve: aceUpMySleeveArt,
  all_seeing_eye: allSeeingEyeArt,
  bounty_hunter: bountyHunterArt,
  clairvoyance: clairvoyanceArt,
  dumpster_diver: dumpsterDiverArt,
  ghost: ghostArt,
  lifeline: lifelineArt,
  magic_trick: magicTrickArt,
  mind_change: mindChangeArt,
  pacifist: pacifistArt,
  power_infusion: powerInfusionArt,
  raging_madness: ragingMadnessArt,
  redirect: redirectArt,
  shortest_king: shortestKingArt,
  trenbologna: trenbolognaArt,

  // COMPLETE: every artKey in the catalog resolves to an image here, so PupCard's blank
  // placeholder frame is now a pure safety net (an unknown code / a card added without art).
  // The only deliberate sharers left are Cancel2 -> Cancel and Counter2 -> Counter above,
  // plus the street variants that have always shared one key (Power-Up, Skip, Peeper,
  // Suit Change) and Psychic 1/2/3.
};

export default pupCardArt;
